import { PathMenuItem } from "core/FeaturePathMenus";

export const pathMenus: PathMenuItem[] = [
  {
    url_id: "/list/kelola-nasabah/blokir-hak-akses-bsya-junior",
    url_path: "/list/kelola-nasabah/blokir-hak-akses-bsya-junior",
  },
  {
    url_id: "/list/kelola-nasabah/blokir-hak-akses-bsya-junior",
    url_path: "/form/kelola-nasabah/blokir-hak-akses-bsya-junior",
  },

  {
    url_id: "/list/persetujuan/blokir-hak-akses",
    url_path: "/list/persetujuan/blokir-hak-akses",
  },
  {
    url_id: "/list/persetujuan/blokir-hak-akses",
    url_path: "/form/persetujuan/blokir-hak-akses",
  },
];
